import Vue from "vue";
import Vuetify from "vuetify/lib/framework";
import es from "vuetify/es5/locale/es";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#780b17",
        secondary: "#a51021",
        accent: "#780b17",
        error: "#ffae52",
        info: "#1a34c8",
        success: "#4CAF50",
        warning: "#ffc107",
      },
    },
  },
  lang: {
    locales: { es },
    current: "es",
  },
});
